import React from 'react';
import cn from 'classnames';
import Link from 'components/UI/Link';
import { pushCustomEvent } from 'utils/analytics';
import * as styles from './Button.module.scss';

function Button({
  theme = 'primary',
  size = 'md',
  fullWidthMobile,
  disabled,
  children,
  className,
  tag = 'button',
  onClick,
  ...other
}) {
  const Wrapper = tag === 'a' ? Link : tag;

  const handleClick = e => {
    const buttonName = typeof children === 'string' ? children : 'button';
    pushCustomEvent('ndrsn_button_interaction', {
      action: 'click_on_button',
      label: buttonName,
      pageUrl: window.location.href,
    });
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <Wrapper
      className={cn(
        styles.button,
        theme && styles[theme],
        size && styles[size],
        fullWidthMobile && styles.fullWidthMobile,
        disabled && styles.disabled,
        className,
      )}
      disabled={disabled}
      onClick={handleClick}
      {...other}
    >
      {children}
    </Wrapper>
  );
}

export default Button;
